(function () {

    'use strict';

    angular.module('Services').service('AccountingHistoricalBillingShipmentsTableService', AccountingHistoricalBillingShipmentsTableService);

    AccountingHistoricalBillingShipmentsTableService.$inject = [
        '$filter', 
        'TableLiteFactory',
        'toastr',
        'AccountingService'
    ];

    function AccountingHistoricalBillingShipmentsTableService(
        $filter, 
        TableLiteFactory,
        toastr,
        AccountingService
    ) {
        return function (invoiceId) {
            const tableData = {
                optionAddOns: {
                    buttons: []
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noFooter: false,
                    noTopOptions: false,
                   
                },
                headers: [
                    {
                        label: 'SELECT',
                        class: 'text-center',
                        filter: {
                            type: 'checkbox'
                        }
                    },
                    {
                        label: 'Date of Booking', 
                        viewName: 'dateOfBooking'
                    }, 
                    {
                        label: 'Consignment No.',
                        viewName: 'consignmentId',
                        width: '120px'
                    },
                    {
                        label: 'Carrier', 
                        viewName: 'carrier'
                    }, 
                    {
                        label: 'Service Type', 
                        viewName: 'serviceType'
                    }, 
                    {
                        label: 'No. Of Packages', 
                        viewName: 'noOfPackages'
                    }, 
                    {
                        label: 'Declared Weight',
                        viewName: 'totalChargeableWeight'
                    },
                    {
                        label: 'Charge Weight',
                        viewName: 'chargeableWeight'
                    }, 
                    {
                        label: 'Price Ex. Tax', 
                        viewName: 'priceExTax'
                    }, 
                    {
                        label: 'Tax', 
                        viewName: 'tax'
                    }, 
                    {
                        label: 'Total', 
                        viewName: 'total'
                    }, 
                    {
                        label: 'Actions', 
                        viewName: 'action'
                    }
                ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.CustomerBilling.getShipments,
                callbackFormat: ['id','success','error','filter'],
                paramId:invoiceId,
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data){ return null; }

                angular.forEach(data.content, function (shipment) {
                    shipment.dateOfBooking = $filter('bbaDate')(shipment.bookingDate); 
                    shipment.consigmentId = shipment.consigmentId;
                    shipment.carrier = angular.getObjVal(shipment, 'carrierProfile.name');
                    shipment.serviceType = angular.getObjVal(shipment, 'serviceProfile.name');
                    shipment.chargeableWeight = angular.getObjVal(shipment, 'invoiceDetails.chargeableWeight');
                    shipment.noOfPackages  = shipment.totalNumberOfPackages;

                   
                    shipment.priceExTax = $filter('bbaCurrency')(shipment.amount); 
                    shipment.tax = $filter('bbaCurrency')(shipment.shippingCost.taxes);
                    shipment.total = $filter('bbaCurrency')(shipment.shippingCost.cost);
                    
                    shipment.action = {
                        type: 'button', 
                        buttons: [{
                            text: 'CREATE CASE', 
                            class: 'btn btn-primary btn-quirk btn-sm',
                            action: ()=>{
                                toastr.warning("Feature not implemented yet.");
                            }
                        }]
                    };
                    tableData.data.push(shipment);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountingHistoricalInvoiceShipmentsTableService.js